module.exports = __webpack_public_path__ + "static/img/led_difuso_azul_5mm-1.cb69dc2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/led_difuso_azul_5mm-1.svg
// module id = p4ic
// module chunks = 0